import React from 'react';
import { motion } from 'framer-motion';
import './Services.css';
import cakeImg from '../assets/images/custom-cakes.png';
import pastryImg from '../assets/images/Pastries_&_Treats.webp';
import decorImg from '../assets/images/Cake_Decorations.jpg';
import CupcakesImg from '../assets/images/Cupcakes_&_Boxes.avif';
import DeliveryImg from '../assets/images/Delivery_&_Setup.jpg';
import EventImg from '../assets/images/Event_Catering.jpg';
const Services = () => {
  const services = [
    {
      icon: 'fas fa-birthday-cake',
      title: 'Custom Cakes',
      description: 'Bespoke celebration cakes in a variety of flavours and designs to suit any occasion.',
      image: cakeImg
    },
    {
      icon: 'fas fa-cookie-bite',
      title: 'Pastries & Treats',
      description: 'Freshly baked pastries, bread, and sweet treats made daily.',
      image: pastryImg
    },
    {
      icon: 'fas fa-spray-can',
      title: 'Cake Decorations',
      description: 'Professional decoration services including fondant art, fresh flowers and toppers.',
      image: decorImg
    },
    {
      icon: 'fas fa-box-open',
      title: 'Cupcakes & Boxes',
      description: 'Customized cupcake boxes for parties, corporate gifts and special events.',
      image: CupcakesImg
    },
    {
      icon: 'fas fa-truck',
      title: 'Delivery & Setup',
      description: 'Reliable delivery and event setup so your order arrives perfect and on time.',
      image: DeliveryImg
    },
    {
      icon: 'fas fa-hands-helping',
      title: 'Event Catering',
      description: 'Full catering options for small to medium events — sweets, cakes and dessert tables.',
      image: EventImg
    }
  ];

  return (
    <section id="services" className="services section">
      <div className="container">
        <div className="section-header text-center mb-4">
          <h2>Our Offerings</h2>
          <p>Delicious cakes, pastries and decoration services crafted for your events and celebrations.</p>
        </div>
        
        <div className="services-grid grid grid-3">
          {services.map((service, index) => (
            <motion.div 
              key={index} 
              className="service-card card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              whileHover={{ y: -10, scale: 1.02 }}
            >
              <div className="service-image">
                <img src={service.image} alt={service.title} />
                <div className="service-overlay">
                  <motion.div 
                    className="service-icon"
                    whileHover={{ scale: 1.2, rotate: 360 }}
                    transition={{ duration: 0.3 }}
                  >
                    <i className={service.icon}></i>
                  </motion.div>
                </div>
              </div>
              <div className="service-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;